export const common = {
  // Navigation
  'nav.features': 'Características',
  'nav.howItWorks': 'Cómo funciona',
  'nav.pricing': 'Precios',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Sobre nosotros',
  'nav.getStarted': 'Comenzar',

  // About Us Section
  'aboutUs.badge': "Sobre nosotros",
  'aboutUs.title': "Discutimos con tu idea para que no discutas con la realidad más tarde.",
  'aboutUs.line1': "La mayoría de las ideas no fracasan por falta de talento del fundador.",
  'aboutUs.line2': "Fracasan porque nadie dijo la verdad a tiempo — cuando cambiar de rumbo aún era barato.",
  'aboutUs.paragraph1': "IdeaVerdict cierra esa brecha. Sometemos tu idea a presión contra las señales de mercado que realmente deciden los resultados: demanda, competencia, capital, tiempo, escalabilidad. No comerciamos con motivación. Comerciamos con evidencia de mercado.",
  'aboutUs.belief1a': "No comerciamos con motivación.",
  'aboutUs.belief1b': "Comerciamos con evidencia de mercado.",
  'aboutUs.belief2a': "No vendemos esperanza.",
  'aboutUs.belief2b': "Vendemos una lectura clara de lo que enfrenta tu idea.",
  'aboutUs.mission1': "Nuestro trabajo no es hacer que tu idea se vea bien.",
  'aboutUs.mission2': "Nuestro trabajo es decirte si realmente lo es.",
  'aboutUs.analysis': "Puntuamos tu idea sobre siete factores que deciden si sobrevive: demanda, competencia, capital inicial, tiempo hasta los ingresos, potencial de beneficio, escalabilidad y riesgo. Sin emoción. Sin optimismo. Solo análisis.",
  'aboutUs.failure1': "La mayoría de los negocios fracasan.",
  'aboutUs.failure2': "No porque la gente detrás fuera incompetente —",
  'aboutUs.failure3': "sino porque nadie contradijo lo suficientemente fuerte, a tiempo.",
  'aboutUs.clarity': "Existimos para contradecir.",
  'aboutUs.value1': "Directo.",
  'aboutUs.value2': "Honesto.",
  'aboutUs.value3': "Rápido.",
  'aboutUs.confirm': "Si tu idea tiene sustancia, la respaldamos.",
  'aboutUs.deny': "Si no, te lo decimos a la cara.",
  'aboutUs.noApplause': "Sin aplausos.",
  'aboutUs.noSugarcoating': "Sin animar.",
  'aboutUs.noTheater': "Sin teatro.",
  'aboutUs.noHype': "Solo el veredicto.",
  // Hero Section
  'hero.badge': 'Decide antes de construir',
  'hero.title1': 'Tu idea, puntuada por una IA',
  'hero.title2': 'que no te adulará.',
  'hero.subtitle': 'Siete dimensiones duras. Un veredicto. En menos de un minuto.',
  'hero.subtitleLine2': 'Descubre si tu idea de negocio tiene una oportunidad real — antes de pasar el próximo año descubriéndolo por las malas.',
  'hero.cta': 'Puntuar mi idea',
  'hero.ctaSecondary': 'Ver cómo funciona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Créditos por solicitud',
  'hero.stat2Value': '7',
  'hero.stat2Label': 'Dimensiones de evaluación',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honesto y privado',

  // Features Section
  'features.title1': 'Hecho para',
  'features.title2': 'fundadores',
  'features.title3': 'que quieren señal, no ruido.',
  'features.bullet1.title': 'Una segunda opinión en la que puedes confiar',
  'features.bullet1.description': 'Cada análisis se califica Fuerte, Mixto o Débil — con el razonamiento detrás. Sin aplausos, sin endulzar. Solo lo que el mercado probablemente te dirá.',
  'features.bullet2.title': 'Puntuado por lo que importa al mercado',
  'features.bullet2.description': 'Demanda real. Competencia. Capital necesario. Tiempo hasta los ingresos. Escalabilidad. Lo que los VC miran primero — aplicado a tu idea antes de construir nada.',
  'features.bullet3.title': 'De idea a plan listo para desarrolladores',
  'features.bullet3.description': 'El modo Builder convierte un veredicto aprobado en un briefing estructurado: flujos de usuario, funciones clave, notas técnicas. Saltas la pizarra y se lo entregas directamente a un desarrollador.',

  // How It Works
  'howItWorks.title': 'Cómo funciona',
  'howItWorks.subtitle': 'Cuatro pasos. Unos diez minutos en total.',
  'howItWorks.step1Title': 'Elige tu profundidad',
  'howItWorks.step1Desc': 'Starter para chequeos rápidos. Pro para análisis completo. Builder para briefings listos para enviar. Elige lo que corresponda a tu etapa.',
  'howItWorks.step2Title': 'Cuéntale tu idea a la IA',
  'howItWorks.step2Desc': 'Un párrafo. Cuanto más claro lo escribas, más afilado el veredicto. Cada análisis cuesta 30 créditos.',
  'howItWorks.step3Title': 'Lee el veredicto',
  'howItWorks.step3Desc': 'Fuerte, Mixto o Débil — sobre siete dimensiones. Más una puntuación sobre 100 con la que puedes discutir.',
  'howItWorks.step4Title': 'Decide qué sigue',
  'howItWorks.step4Desc': 'Construirla. Afilarla. Pivotar. Abandonarla. Sabrás qué hacer — y por qué.',

  // Pricing
  'pricing.title': 'Precios',
  'pricing.subtitle': 'Elige el plan que se ajuste a la profundidad de tu revisión.',
  'pricing.monthly': 'Mensual',
  'pricing.yearly': 'Anual',
  'pricing.yearlyDiscount': 'Suscripción anual:',
  'pricing.yearlyDiscountValue': '-20% de descuento',
  'pricing.perMonth': 'por mes',
  'pricing.selectPlan': 'Seleccionar plan',
  'pricing.mostPopular': 'Más popular',
  'pricing.footer': 'Todos los precios en CHF. Los créditos solo se deducen por respuestas exitosas de IA.',

  // Pricing Features
  'pricing.feature1': 'Chat en vivo gratis (sin formulario)',
  'pricing.feature2': 'Lógica de mercado y calificación honesta',
  'pricing.feature3': 'Historial de chat persistente',
  'pricing.feature4': 'Múltiples sesiones de chat paralelas',
  'pricing.feature5': 'Totalmente multilingüe',
  'pricing.feature6': 'Uso basado en créditos',
  'pricing.feature7': 'Restablecimiento mensual',
  'pricing.feature8': 'Análisis de mercado',
  'pricing.feature9': 'Resumen',
  'pricing.feature10': 'Fortalezas',
  'pricing.feature11': 'Debilidades',
  'pricing.feature12': 'Oportunidades',
  'pricing.feature13': 'Riesgos',
  'pricing.feature14': 'Recomendaciones',
  'pricing.feature15': 'Descargar PDF',
  'pricing.feature16': 'Sin sesiones informativas para desarrolladores',
  'pricing.feature17': 'Modo constructor: Sesiones informativas para desarrolladores',
  'pricing.feature18': 'Resumen estructurado',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Para pruebas de realidad iniciales.',
  'pricing.starter.credits': '2,500 créditos',
  'pricing.starter.feature1': 'Generar idea de nicho',
  'pricing.starter.feature2': 'Afinar nicho',
  'pricing.starter.feature3': 'Verificación de realidad del mercado',
  'pricing.starter.feature4': 'Evaluación de competencia',
  'pricing.starter.feature5': 'Evaluación de tiempo',
  'pricing.starter.feature6': 'Veredicto honesto',
  'pricing.starter.feature7': 'Sesiones privadas',
  'pricing.starter.feature8': 'Historial y exportación',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Para revisión más profunda.',
  'pricing.pro.credits': '5,000 créditos',
  'pricing.pro.feature1': 'Todas las características de Starter',
  'pricing.pro.feature2': 'Más créditos para revisión intensiva',
  'pricing.pro.feature3': 'Sugerencias de mejora',
  'pricing.pro.feature4': 'Nichos alternativos',
  'pricing.pro.feature5': 'Análisis de mercado detallado',
  'pricing.pro.feature6': 'Soporte prioritario',
  'pricing.pro.feature7': 'Filtros avanzados',
  'pricing.pro.feature8': 'Favoritos de sesión',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Todas las funciones + modo Builder",
  'pricing.builder.credits': "10.000 créditos al mes",
  'pricing.builder.feature1': 'Todas las características Pro',
  'pricing.builder.feature2': 'Solicitudes de IA ilimitadas',
  'pricing.builder.feature3': 'Modo Builder: Briefing para desarrolladores',
  'pricing.builder.feature4': 'Descripción general del proyecto estructurado',
  'pricing.builder.feature5': 'Flujos de usuario y funciones principales',
  'pricing.builder.feature6': 'Notas técnicas',
  'pricing.builder.feature7': 'Definir no objetivos',
  'pricing.builder.feature8': 'Límite de tasa de uso justo',
  'pricing.builder.limitNote': 'Límite de uso justo',
  'pricing.monthlyReset': 'Reinicio mensual',

  // Modal
  'pricing.modal.selected': 'seleccionado',
  'pricing.modal.comingSoon': 'El registro y el procesamiento de pagos estarán disponibles pronto.',
  'pricing.modal.patience': 'Estamos trabajando para brindarte una experiencia segura y fluida. Por favor, ten paciencia.',
  'pricing.modal.understood': 'Entendido',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Respuestas directas, sin marketing.',
  'faq.q1': "¿Qué hace realmente IdeaVerdict?",
  'faq.a1': "Puntúa tu idea de negocio sobre los siete factores que deciden si sobrevive a un mercado: demanda, competencia, capital inicial, tiempo hasta los ingresos, potencial de beneficio, escalabilidad y riesgo.\nObtienes un veredicto, un número y el razonamiento detrás de ambos.",
  'faq.q2': "¿Pueden generar ideas, o solo criticar las mías?",
  'faq.a2': "Ambas.\nCuéntanos sobre tus habilidades, capital y tiempo — surgirán nichos con huecos reales de mercado.\nO pega la tuya y la diseccionaremos.",
  'faq.q3': "¿En qué se diferencian de ChatGPT?",
  'faq.a3': "ChatGPT intenta ser útil.\nNosotros intentamos ser precisos.\nEstamos afinados para contradecir cuando los números no cuadran — en vez de encontrar razones por las que tu idea es genial.",
  'faq.q4': "¿Garantiza esto que mi idea tendrá éxito?",
  'faq.a4': "Ninguna herramienta garantiza eso.\nTe ayudamos a evitar las apuestas obviamente malas y a afinar las que tienen oportunidad.\nEl riesgo no desaparece — pero entras con los ojos abiertos.",
  'faq.q5': "¿Para quién es esto?",
  'faq.a5': "Fundadores antes del lanzamiento.\nOperadores antes de una apuesta paralela.\nBuilders antes del proyecto del fin de semana.\nInversores antes del cheque.\n\nCualquiera que quiera claridad antes del compromiso.",
  'faq.q6': "¿Y si solo quiero que alguien me diga que mi idea es genial?",
  'faq.a6': "Entonces somos la herramienta equivocada.\nDamos una lectura honesta, no consuelo.",
  'faq.q7': "¿Qué tan honesto es el análisis realmente?",
  'faq.a7': "Tan honesto como los datos permiten.\nNo suavizamos un veredicto débil para no herir sentimientos.\nSi tu idea tiene un problema, lo decimos — y decimos dónde está.",
  'faq.q8': "¿Reemplaza un estudio de mercado real?",
  'faq.a8': "No.\nEs un chequeo estratégico rápido antes de comprometer tiempo y dinero — no un informe de 50 páginas.\nÚsanos para decidir si vale la pena hacer la investigación más profunda.",
  'faq.q9': "¿Qué añade el modo Builder?",
  'faq.a9': "Una vez que un veredicto es positivo, el modo Builder lo convierte en un briefing para desarrolladores: flujos de usuario, funciones clave, modelo de monetización, consideraciones técnicas.\nLo que le entregarías a tu primer ingeniero.",
  'faq.q10': "¿Por qué tan directos?",
  'faq.a10': "Porque construir lo equivocado cuesta meses.\nUn veredicto honesto cuesta minutos.\n\nElegimos los minutos.",
  // Footer
  'footer.description': 'IdeaVerdict no está aquí para hacerte sentir bien con tu idea. Está aquí para ayudarte a decidir si apostar por ella.',
  'footer.product': 'Producto',
  'footer.aiAssistant': 'Asistente IA',
  'footer.howItWorks': 'Cómo funciona',
  'footer.pricing': 'Precios',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Términos',
  'footer.imprint': 'Aviso legal',
  'footer.support': 'Soporte',
  'footer.contact': 'Contacto',
  'footer.documentation': 'Documentación',
  'footer.copyright': '© 2026 IdeaVerdict. Todos los derechos reservados.',

  // AI Assistant
  'aiAssistant.title': 'Asistente IA de nichos',
  'aiAssistant.subtitle': 'Preguntar sobre nichos',
  'aiAssistant.welcomeMessage': '¡Hola! Describe tu idea o pregúntame sobre un nicho. Te daré una evaluación clara y honesta.',
  'aiAssistant.demoResponse': 'Esto es una demostración. Para obtener evaluaciones reales de IA, regístrate y elige un plan.',
  'aiAssistant.placeholder': 'Describe tu idea...',

  // Header & Sidebar
  'dashboard.header.title': 'Panel',
  'dashboard.header.aiAssistant': 'Tu Asistente IA',
  'header.logout': 'Cerrar Sesión',
  'dashboard.sidebar.overview': 'Resumen',
  'dashboard.sidebar.aiChat': 'Asistente IA',
  'dashboard.sidebar.newAnalysis': 'Asistente IA',
  'dashboard.sidebar.history': 'Historial',
  'dashboard.sidebar.credits': 'Créditos',
  'dashboard.sidebar.settings': 'Configuración',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bienvenido de nuevo, {{name}}',
  'dashboard.overview.subtitle': 'Aquí tienes un resumen rápido de tu actividad',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Créditos restantes',
  'dashboard.stats.totalAnalyses': 'Análisis totales',
  'dashboard.stats.goodRatings': 'Valoraciones positivas',
  'dashboard.stats.nextReset': 'Próximo reinicio en',
  'dashboard.stats.days': 'días',

  // Quick Actions
  'dashboard.quickActions.title': 'Acciones rápidas',
  'dashboard.quickActions.checkNewIdea': 'Verificar una idea',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analizar una idea de negocio existente',
  'dashboard.quickActions.generateIdea': 'Generar una idea',
  'dashboard.quickActions.generateIdeaDesc': 'Encontrar un nuevo nicho rentable',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Convertir una idea en un briefing listo para desarrolladores',
  'dashboard.quickActions.premiumOnly': 'Solo Builder',

  // Chat Header
  'chat.title': 'Asistente IA de nichos',
  'chat.subtitle': 'Haz preguntas sobre nichos. Evalúo de forma crítica y honesta.',
  'chat.creditsLabel': 'Créditos',

  // Chat Welcome
  'chat.welcomeTitle': 'Bienvenido al Asistente IA de nichos',
  'chat.welcomeDesc': 'Describe tu idea o pregunta sobre un nicho. Lo evaluaré honestamente: Bueno, Promedio o Malo.',
  'chat.aiWelcome': '¡Hola! Describe tu idea o pregúntame sobre un nicho. Te daré una evaluación clara y honesta.',

  // Chat Suggestions
  'chat.suggestion1': 'Quiero crear una herramienta SaaS para freelancers para gestionar facturas. ¿Es un buen nicho?',
  'chat.suggestion2': 'Encuéntrame un negocio online con poca competencia que pueda empezar con $500 sin saber programar.',
  'chat.suggestion3': 'Evalúa esto: una app de planificación de comidas con IA para padres ocupados con restricciones dietéticas.',
  'chat.suggestion4': 'Quiero vender plantillas digitales en Etsy para pequeños empresarios. Analiza este nicho honestamente.',

  // Chat Actions
  'chat.newConversation': 'Nueva conversación',
  'chat.today': 'Hoy',
  'chat.yesterday': 'Ayer',
  'chat.thisWeek': 'Esta semana',
  'chat.thisMonth': 'Este mes',
  'chat.older': 'Más antiguo',
  'chat.messages': 'mensajes',
  'chat.renameConversation': 'Renombrar',
  'chat.deleteConversation': 'Eliminar',
  'chat.cancel': 'Cancelar',
  'chat.rename': 'Renombrar',
  'chat.delete': 'Eliminar',
  'chat.favorite': 'Añadir favorito',
  'chat.unfavorite': 'Quitar favorito',
  'chat.searchSessions': 'Buscar conversaciones...',
  'chat.noResults': 'No se encontraron resultados',
  'chat.noSessions': 'Aún no hay conversaciones',
  'chat.enterNewName': 'Introduce un nuevo nombre...',
  'chat.deleteConfirmMessage': '¿Estás seguro de que quieres eliminar esta conversación? Esta acción no se puede deshacer.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Escribe tu pregunta… (cuesta 30 créditos)',
  'chat.send': 'Enviar',
  'chat.voice': 'Hablar',
  'chat.listeningPlaceholder': 'Estoy escuchando... Habla ahora.',
  'chat.stopListening': 'Detener grabación',
  'chat.recording': 'Grabando...',
  'chat.speechNotSupported': 'El reconocimiento de voz no es compatible con tu navegador.',
  'chat.microphonePermissionDenied': 'Se denegó el acceso al micrófono. Por favor, permite el acceso en la configuración de tu navegador.',
  'chat.errorNotEnoughCredits': 'No hay suficientes créditos. Por favor, actualiza tu plan o espera al próximo reinicio.',
  'chat.errorAiFailed': 'La respuesta de IA falló. No se dedujeron créditos.',
  'chat.errorRateLimit': 'Demasiadas solicitudes. Por favor, espera un momento.',

  // Ratings
  'rating.good': 'Bueno',
  'rating.medium': 'Promedio',
  'rating.bad': 'Malo',

  // Auth Page
  'auth.branding.headline1': 'No todas las ideas son buenas.',
  'auth.branding.headline2': 'Te lo decimos honestamente.',
  'auth.branding.subtitle': 'Una IA de decisión para nichos de negocio. Clara. Crítica. Sin endulzar.',
  'auth.benefits.privacy.title': '100% Privado',
  'auth.benefits.privacy.desc': 'Tus ideas permanecen completamente privadas y seguras.',
  'auth.benefits.honest.title': 'IA Honesta',
  'auth.benefits.honest.desc': 'Sin endulzar – solo feedback claro y crítico.',
  'auth.benefits.fast.title': 'Resultados Rápidos',
  'auth.benefits.fast.desc': 'Obtén claridad sobre tu nicho en minutos.',
  'auth.trust.users': 'Usuarios Activos',
  'auth.trust.ideas': 'Ideas Analizadas',
  'auth.trust.rating': 'Valoración',
  'auth.login.title': 'Iniciar Sesión',
  'auth.login.headline': 'Bienvenido de nuevo',
  'auth.login.subtitle': 'Inicia sesión para continuar tu viaje.',
  'auth.login.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.login.submit': 'Iniciar Sesión',
  'auth.login.noAccount': '¿No tienes cuenta?',
  'auth.login.signUp': 'Regístrate',
  'auth.register.title': 'Registrarse',
  'auth.register.headline': 'Crea tu cuenta',
  'auth.register.subtitle': 'Comienza a analizar tus ideas de negocio hoy.',
  'auth.register.submit': 'Crear Cuenta',
  'auth.register.hasAccount': '¿Ya tienes una cuenta?',
  'auth.register.signIn': 'Iniciar sesión',
  'auth.fields.name': 'Nombre Completo',
  'auth.fields.email': 'Correo Electrónico',
  'auth.fields.password': 'Contraseña',
  'auth.fields.confirmPassword': 'Confirmar Contraseña',
  'auth.fields.selectPlan': 'Selecciona tu plan',
  'auth.fields.testCode': 'Iniciar sesión y probar gratis',
  'auth.placeholders.name': 'Ingresa tu nombre',
  'auth.placeholders.email': 'Ingresa tu correo',
  'auth.placeholders.password': 'Ingresa tu contraseña',
  'auth.placeholders.confirmPassword': 'Confirma tu contraseña',
  'auth.placeholders.testCode': 'Ingresa el código de prueba',
  'auth.terms.accept': 'Acepto los',
  'auth.terms.terms': 'Términos y Condiciones',
  'auth.privacy.accept': 'Acepto la',
  'auth.privacy.policy': 'Política de Privacidad',
  'auth.errors.nameRequired': 'El nombre es obligatorio',
  'auth.errors.emailRequired': 'El correo es obligatorio',
  'auth.errors.emailInvalid': 'Por favor ingresa un correo válido',
  'auth.errors.passwordRequired': 'La contraseña es obligatoria',
  'auth.errors.passwordLength': 'La contraseña debe tener al menos 8 caracteres',
  'auth.errors.passwordMismatch': 'Las contraseñas no coinciden',
  'auth.errors.invalidCode': 'Código inválido o expirado',
  'auth.errors.registrationCodeOnly': 'Este código es solo para registro',
  'auth.errors.verificationFailed': 'Error verificando el código. Por favor intenta de nuevo.',
  'auth.loading': 'Por favor espera...',
  'auth.or': 'o continuar con',
  'auth.social.google': 'Continuar con Google',
  'auth.social.apple': 'Continuar con Apple',
  'auth.actions.verify': 'Verificar',
  'auth.testCode.activated': '¡Código de prueba activado!',
  'auth.testCode.days': 'días',
  'auth.testCode.months': 'meses',
  'auth.testCode.freeAccess': 'acceso gratuito',
  'auth.testCode.credits': 'créditos',

  // Email Verification
  'auth.verification.title': 'Verificar Email',
  'auth.verification.headline': 'Revisa tu bandeja de entrada',
  'auth.verification.subtitle': 'Enviamos un código de verificación a:',
  'auth.verification.codeLabel': 'Código de Verificación',
  'auth.verification.codePlaceholder': 'Ingresa el código de 6 dígitos',
  'auth.verification.submit': 'Verificar Email',
  'auth.verification.resend': 'Reenviar código',
  'auth.verification.resendIn': 'Reenviar en',
  'auth.verification.seconds': 'segundos',
  'auth.verification.success': '¡Email verificado con éxito!',
  'auth.verification.error': 'Código inválido. Por favor intenta de nuevo.',
  'auth.verification.expired': 'Código expirado. Por favor solicita uno nuevo.',
  'auth.verification.sent': '¡Nuevo código enviado!',
  'auth.verification.checkSpam': '¿No lo recibiste? Revisa tu carpeta de spam.',

  // Forgot Password
  'auth.forgot.title': 'Olvidé mi contraseña',
  'auth.forgot.headline': 'Restablece tu contraseña',
  'auth.forgot.subtitle': 'Ingresa tu correo electrónico y te enviaremos un enlace de restablecimiento.',
  'auth.forgot.submit': 'Enviar Enlace de Restablecimiento',
  'auth.forgot.backToLogin': 'Volver al inicio de sesión',
  'auth.forgot.success': '¡Correo enviado!',
  'auth.forgot.successMessage': 'Te enviamos un correo con instrucciones para restablecer tu contraseña.',
  'auth.forgot.checkInbox': 'Revisa tu bandeja de entrada',

  // Reset Password
  'auth.reset.title': 'Nueva Contraseña',
  'auth.reset.headline': 'Establece una nueva contraseña',
  'auth.reset.subtitle': 'Ingresa tu nueva contraseña.',
  'auth.reset.newPassword': 'Nueva Contraseña',
  'auth.reset.confirmNewPassword': 'Confirmar Nueva Contraseña',
  'auth.reset.submit': 'Cambiar Contraseña',
  'auth.reset.success': '¡Contraseña cambiada con éxito!',
  'auth.reset.successMessage': 'Ahora puedes iniciar sesión con tu nueva contraseña.',
  'auth.reset.loginNow': 'Iniciar sesión ahora',

  // Legal Pages
  'legal.backToAuth': 'Volver al inicio de sesión',
  'legal.allRightsReserved': 'Todos los derechos reservados.',

  // Terms Page
  'legal.terms.title': 'Términos y Condiciones',
  'legal.terms.lastUpdated': 'Última actualización',
  'legal.terms.section1.title': '1. Alcance',
  'legal.terms.section1.content': 'Estos Términos y Condiciones se aplican a todos los contratos entre NicheFinder (en adelante "Proveedor") y el usuario (en adelante "Cliente") relativos al uso de la plataforma de análisis de nichos impulsada por IA.',
  'legal.terms.section2.title': '2. Descripción del Servicio',
  'legal.terms.section2.content': 'El Proveedor ofrece una plataforma basada en IA que analiza y evalúa ideas de negocio y nichos. Los servicios incluyen:',
  'legal.terms.section2.item1': 'Análisis de ideas de negocio impulsado por IA',
  'legal.terms.section2.item2': 'Evaluación del potencial de mercado y la competencia',
  'legal.terms.section2.item3': 'Generación de sugerencias de nichos',
  'legal.terms.section2.item4': 'Creación de briefings para desarrolladores (paquete Builder)',
  'legal.terms.section3.title': '3. Celebración del Contrato y Registro',
  'legal.terms.section3.content': 'El contrato se celebra mediante el registro en la plataforma y la selección de un paquete. El cliente confirma:',
  'legal.terms.section3.item1': 'Ser mayor de edad y tener plena capacidad jurídica',
  'legal.terms.section3.item2': 'Proporcionar información veraz durante el registro',
  'legal.terms.section3.item3': 'Almacenamiento seguro de las credenciales de acceso',
  'legal.terms.section4.title': '4. Créditos y Facturación',
  'legal.terms.section4.content': 'El uso de las funciones de IA se basa en un sistema de créditos. Cada consulta de IA cuesta 30 créditos. Los créditos solo se deducen si la respuesta es exitosa. Los créditos no utilizados caducan al final del período de facturación y no se reembolsan.',
  'legal.terms.section5.title': '5. Descargo de Responsabilidad',
  'legal.terms.section5.content': 'Las evaluaciones de la IA sirven únicamente como ayuda para la toma de decisiones y no garantizan el éxito empresarial. El Proveedor no es responsable de las decisiones tomadas en base a los análisis de la IA. La responsabilidad por intención y negligencia grave permanece inalterada.',
  'legal.terms.section6.title': '6. Protección de Datos y Confidencialidad',
  'legal.terms.section6.content': 'Todas las ideas de negocio enviadas se tratan de forma confidencial y no se comparten con terceros. El procesamiento de datos personales se lleva a cabo de acuerdo con nuestra Política de Privacidad y las leyes de protección de datos aplicables.',
  'legal.terms.section7.title': '7. Rescisión',
  'legal.terms.section7.content': 'El cliente puede cancelar su suscripción en cualquier momento al final del período de facturación actual. En caso de incumplimiento de estos Términos, el Proveedor se reserva el derecho de bloquear el acceso a la plataforma.',
  'legal.terms.section8.title': '8. Disposiciones Finales',
  'legal.terms.section8.content': 'Se aplica la ley suiza. El lugar de jurisdicción es Zúrich, Suiza. Si alguna disposición de estos Términos no es válida, la validez de las disposiciones restantes permanece inalterada.',
  'legal.terms.contact.title': '¿Preguntas sobre los Términos?',
  'legal.terms.contact.content': 'Si tienes preguntas sobre estos Términos y Condiciones, contáctanos en:',

  // Privacy Page
  'legal.privacy.title': 'Política de Privacidad',
  'legal.privacy.section1.title': '1. Controlador de Datos',
  'legal.privacy.section1.content': 'El controlador de datos de este sitio web es NicheFinder, Zúrich, Suiza. Nos tomamos muy en serio la protección de tus datos personales y los tratamos de forma confidencial y de acuerdo con las regulaciones legales de protección de datos.',
  'legal.privacy.section2.title': '2. Datos Recopilados',
  'legal.privacy.section2.content': 'Recopilamos y procesamos los siguientes datos personales:',
  'legal.privacy.section2.item1': 'Datos de registro: Nombre, dirección de correo electrónico, contraseña (cifrada)',
  'legal.privacy.section2.item2': 'Datos de uso: Dirección IP, tipo de navegador, tiempos de acceso',
  'legal.privacy.section2.item3': 'Ideas de negocio y consultas de nichos (almacenadas de forma anónima)',
  'legal.privacy.section2.item4': 'Información de pago (a través de proveedores de terceros seguros)',
  'legal.privacy.section3.title': '3. Finalidad del Procesamiento de Datos',
  'legal.privacy.section3.content': 'Tus datos se utilizan para los siguientes fines:',
  'legal.privacy.section3.item1': 'Provisión y mejora de nuestros servicios de IA',
  'legal.privacy.section3.item2': 'Gestión de cuentas y autenticación',
  'legal.privacy.section3.item3': 'Facturación y procesamiento de pagos',
  'legal.privacy.section4.title': '4. Seguridad de Datos',
  'legal.privacy.section4.content': 'Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos contra manipulación, pérdida, destrucción o acceso no autorizado. Todas las transferencias de datos están cifradas mediante SSL/TLS.',
  'legal.privacy.section5.title': '5. Confidencialidad de tus Ideas de Negocio',
  'legal.privacy.section5.content': 'Tus ideas de negocio e consultas de nichos enviadas se tratan de forma estrictamente confidencial. No se comparten con terceros, no se utilizan para fines de entrenamiento y pueden eliminarse completamente a petición. Tus ideas te pertenecen.',
  'legal.privacy.section6.title': '6. Tus Derechos',
  'legal.privacy.section6.content': 'Tienes los siguientes derechos con respecto a tus datos personales:',
  'legal.privacy.section6.item1': 'Derecho de acceso a los datos almacenados',
  'legal.privacy.section6.item2': 'Derecho de rectificación de datos inexactos',
  'legal.privacy.section6.item3': 'Derecho de eliminación de tus datos',
  'legal.privacy.section6.item4': 'Derecho a la portabilidad de datos',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content': 'Nuestro sitio web solo utiliza cookies técnicamente necesarias para la autenticación y gestión de sesiones. No utilizamos cookies de seguimiento ni herramientas de análisis de terceros sin tu consentimiento explícito.',
  'legal.privacy.section8.title': '8. Cambios en esta Política de Privacidad',
  'legal.privacy.section8.content': 'Nos reservamos el derecho de adaptar esta política de privacidad para cumplir con los requisitos legales modificados o cuando se produzcan cambios en el servicio. La versión actual siempre se puede encontrar en esta página.',
  'legal.privacy.contact.title': '¿Preguntas sobre Privacidad?',
  'legal.privacy.contact.content': 'Si tienes preguntas sobre el procesamiento de tus datos personales, contáctanos en:',

  'auth.passwordStrength.label': 'Seguridad de la contraseña',
  'auth.passwordStrength.weak': 'Débil',
  'auth.passwordStrength.medium': 'Media',
  'auth.passwordStrength.strong': 'Fuerte',
  'auth.passwordStrength.veryStrong': 'Muy fuerte',
  'auth.passwordStrength.minLength': 'Mín. 8 caracteres',
  'auth.passwordStrength.uppercase': 'Letra mayúscula',
  'auth.passwordStrength.number': 'Número',
  'auth.passwordStrength.special': 'Carácter especial',

  trial: {
    subtitle: 'Prueba Gratuita',
    upgrade: 'Actualizar Ahora',
    creditsRemaining: 'créditos restantes',
    inputHint: 'Versión de prueba - Sin historial de conversaciones',
    banner: {
      title: 'Prueba de 7 Días Activa',
      remaining: '{{days}} días restantes',
      credits: 'créditos disponibles',
      upgradeNow: 'Actualizar Ahora',
    },
    welcome: {
      title: '¡Bienvenido a la Prueba Gratuita!',
      desc: 'Prueba nuestro asistente de IA gratis durante 7 días con 100 créditos. ¡Haz preguntas y descubre las posibilidades!',
    },
    info: {
      title: 'Limitaciones de la Prueba',
      credits: '100 créditos por 7 días',
      noHistory: 'Sin historial de conversaciones',
      noSettings: 'Funciones limitadas',
      upgrade: 'Actualiza para obtener funciones completas',
    },
  },

  'admin.title': 'Panel de Administración',
  'admin.subtitle': 'Centro de Control',
  'admin.superAdmin': 'Super Admin',
  'admin.logout': 'Cerrar Sesión',
  'admin.tabs.users': 'Gestión de Usuarios',
  'admin.tabs.downgrades': 'Degradaciones',
  'admin.tabs.tips': 'Consejo del Día',
  'admin.tabs.coupons': 'Códigos de Cupón',
  'admin.tabs.website': 'Editor del Sitio',
  'admin.tabs.ai': 'Ajustes de IA',
  'admin.tabs.transactions': 'Registro de Transacciones',
  'admin.tabs.stats': 'Estadísticas',
  'admin.users.searchPlaceholder': 'Buscar usuarios (correo o nombre)...',
  'admin.users.manageSubscription': 'Gestionar suscripción',
  'admin.users.grantFree': 'Conceder acceso gratuito',
  'admin.users.blockUser': 'Bloquear usuario',
  'admin.users.unblockUser': 'Desbloquear usuario',
  'admin.users.cancellationPlaceholder': '¿Por qué se cancela la suscripción?',
  'admin.users.selectPlan': 'Seleccionar plan',
  'admin.users.subChanged': 'Suscripción de {{name}} cambiada a {{plan}}',
  'admin.users.noReasonGiven': 'Sin razón indicada',
  'admin.users.subCancelled': 'Suscripción de {{name}} cancelada (válida hasta {{date}})',
  'admin.users.paused': 'En pausa',
  'admin.users.subPaused': 'La suscripción de {{name}} ha sido pausada',
  'admin.users.subReactivated': 'La suscripción de {{name}} ha sido reactivada',
  'admin.users.freeAccount': 'Cuenta Gratuita',
  'admin.users.blocked': 'Bloqueado',
  'admin.users.cancelledExpiring': 'Cancelado (expira pronto)',
  'admin.users.cancelledOn': 'Cancelado:',
  'admin.users.endsOn': 'Termina:',
  'admin.users.daysRemaining': 'días restantes',
  'admin.table.user': 'Usuario',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Estado de Suscripción',
  'admin.table.cancellation': 'Cancelación',
  'admin.table.payment': 'Método de Pago',
  'admin.table.spending': 'Gasto',
  'admin.table.actions': 'Acciones',
  'admin.actions.viewDetails': 'Ver detalles',
  'admin.actions.manageSubscription': 'Gestionar suscripción',
  'admin.actions.grantFree': 'Conceder acceso gratuito',
  'admin.actions.block': 'Bloquear usuario',
  'admin.actions.unblock': 'Desbloquear usuario',
  'admin.actions.cancel': 'Cancelar',
  'admin.actions.save': 'Guardar',
  'admin.actions.delete': 'Eliminar',
  'admin.actions.confirm': 'Confirmar',
  'admin.actions.done': 'Hecho',
  'admin.actions.edit': 'Editar',
  'admin.filter.all': 'Todos',
  'admin.subscription.active': 'Activo',
  'admin.subscription.cancelled': 'Cancelado',
  'admin.subscription.paused': 'En pausa',
  'admin.subscription.unknown': 'Desconocido',
  'admin.status.active': 'Activo',
  'admin.status.inactive': 'Inactivo',
  'admin.status.pending': 'Pendiente',
  'admin.status.approved': 'Aprobado',
  'admin.status.rejected': 'Rechazado',
  'admin.coupons.title': 'Gestión de Cupones',
  'admin.coupons.subtitle': 'Crear y gestionar códigos de cupón',
  'admin.coupons.newCoupon': 'Nuevo Cupón',
  'admin.coupons.registrationCoupons': 'Cupones de Registro',
  'admin.coupons.trialCoupons': 'Cupones de Acceso de Prueba',
  'admin.coupons.type': 'Tipo',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Valor',
  'admin.coupons.usage': 'Uso',
  'admin.coupons.validUntil': 'Válido Hasta',
  'admin.coupons.created': 'Creado',
  'admin.coupons.actions': 'Acciones',
  'admin.coupons.copyCode': 'Copiar código',
  'admin.coupons.allPlans': 'Todos los Planes',
  'admin.coupons.discount': 'Descuento',
  'admin.coupons.days': 'días',
  'admin.coupons.months': 'meses',
  'admin.coupons.free': 'gratis',
  'admin.coupons.unlimited': 'Ilimitado',
  'admin.coupons.createRegistration': 'Crear Cupón de Registro',
  'admin.coupons.createTrial': 'Crear Cupón de Prueba',
  'admin.coupons.couponCode': 'Código de Cupón',
  'admin.coupons.codePlaceholder': 'ej. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generar nuevo código',
  'admin.coupons.alertFillRequired': 'Por favor rellene todos los campos obligatorios',
  'admin.coupons.alertSelectExpiry': 'Por favor seleccione una fecha de vencimiento o active "Validez ilimitada"',
  'admin.coupons.alertCreateError': 'Error al crear el cupón',
  'admin.coupons.confirmDelete': '¿Está seguro de que desea eliminar este cupón?',
  'admin.coupons.discountPercent': 'Descuento (%)',
  'admin.coupons.bonusCredits': 'Créditos Bonus',
  'admin.coupons.freeDuration': 'Duración Gratuita',
  'admin.coupons.maxUses': 'Usos Máximos',
  'admin.coupons.expiryDate': 'Fecha de Vencimiento',
  'admin.coupons.unlimitedValidity': 'Validez ilimitada',
  'admin.coupons.unlimitedUses': 'Usos ilimitados',
  'admin.coupons.trialCredits': 'Créditos de Prueba',
  'admin.coupons.trialDuration': 'Duración de Prueba',
  'admin.coupons.typePlaceholder': 'ej. Early Bird, Socio, Influencer',
  'admin.coupons.duration': 'Duración',
  'admin.stats.totalUsers': 'Total de Usuarios',
  'admin.stats.monthlyRevenue': 'Ingresos Mensuales',
  'admin.stats.activeSubscriptions': 'Suscripciones Activas',
  'admin.stats.average': 'Promedio',
  'admin.stats.revenuePerUser': 'Ingresos por Usuario',
  'admin.stats.grossRevenue': 'Ingresos Brutos',
  'admin.stats.net': 'NETO',
  'admin.stats.netRevenue': 'Ingresos Netos',
  'admin.stats.churnRate': 'Tasa de Cancelación',
  'admin.stats.planDistribution': 'Distribución de Planes',
  'admin.stats.users': 'usuarios',
  'admin.stats.revenueByPlan': 'Ingresos por Plan',
  'admin.stats.recentActivity': 'Actividad Reciente',
  'admin.stats.activity1': 'Thomas Weber mejoró a Builder',
  'admin.stats.activity2': 'Nuevo usuario registrado',
  'admin.stats.activity3': 'Anna Schmidt mejoró a Pro',
  'admin.stats.hoursAgo2': 'Hace 2 horas',
  'admin.stats.hoursAgo5': 'Hace 5 horas',
  'admin.stats.dayAgo1': 'Hace 1 día',
  'admin.stats.couponStats': 'Estadísticas de Cupones',
  'admin.stats.totalRedemptions': 'Total de Canjes',
  'admin.stats.activeCoupons': 'Cupones Activos',
  'admin.stats.registrationRedemptions': 'Canjes de Registro',
  'admin.stats.trialRedemptions': 'Canjes de Prueba',
  'admin.stats.couponDistribution': 'Distribución de Cupones',
  'admin.stats.registrationCoupons': 'Cupones de Registro',
  'admin.stats.trialCoupons': 'Cupones de Prueba',
  'admin.stats.expiredInactive': 'Expirados/Inactivos',
  'admin.stats.topCoupons': 'Mejores Cupones por Canjes',
  'admin.stats.redemptions': 'canjes',
  'admin.stats.noCouponsRedeemed': 'Aún no se han canjeado cupones',
  'admin.downgrade.pending': 'pendiente',
  'admin.downgrade.refunds': 'Reembolsos',
  'admin.downgrade.sectionRequests': 'Solicitudes',
  'admin.downgrade.sectionStats': 'Estadísticas',
  'admin.downgrade.sectionRules': 'Reglas',
  'admin.downgrade.pendingRequests': 'Solicitudes Pendientes',
  'admin.downgrade.approvedRequests': 'Solicitudes Aprobadas',
  'admin.downgrade.rejectedRequests': 'Solicitudes Rechazadas',
  'admin.downgrade.activeRules': 'Reglas Activas',
  'admin.downgrade.autoRules': 'Reglas de Degradación Automática',
  'admin.downgrade.autoRulesDesc': 'Cree reglas que activen automáticamente degradaciones según el comportamiento de uso',
  'admin.downgrade.newRule': 'Nueva Regla',
  'admin.downgrade.totalRules': 'Total de Reglas',
  'admin.downgrade.triggeredActions': 'Acciones Activadas',
  'admin.downgrade.conditionsAnd': 'Condiciones (vinculadas por Y)',
  'admin.downgrade.action': 'Acción',
  'admin.downgrade.successTitle': '¡Degradación exitosa!',
  'admin.downgrade.successDesc': 'El usuario ha sido degradado con éxito y el reembolso ha sido procesado.',
  'admin.downgrade.closing': 'Cerrando...',
  'admin.downgrade.title': 'Degradar Usuario',
  'admin.downgrade.currentPlan': 'Plan Actual',
  'admin.downgrade.spending': 'Gasto',
  'admin.downgrade.availablePlans': 'Planes Disponibles para Degradación',
  'admin.downgrade.perMonth': 'por mes',
  'admin.downgrade.refundCalc': 'Cálculo de Reembolso',
  'admin.downgrade.currentPlanLabel': 'Plan Actual',
  'admin.downgrade.newPlan': 'Nuevo Plan',
  'admin.downgrade.remainingDays': 'Días Restantes',
  'admin.downgrade.daysOf': '15 de 30 días',
  'admin.downgrade.proRataRefund': 'Reembolso Proporcional',
  'admin.downgrade.importantNote': 'Nota Importante',
  'admin.downgrade.warningDesc': 'La degradación se ejecutará inmediatamente. El usuario perderá acceso a las funciones premium y los créditos excedentes serán eliminados.',
  'admin.downgrade.processing': 'Procesando...',
  'admin.downgrade.execute': 'Ejecutar Degradación',
  'admin.downgrade.notification': 'Notificación',
  'admin.downgrade.noNotification': 'Sin Notificación',
  'admin.downgrade.daysPeriod': 'días de periodo de gracia',
  'admin.downgrade.created': 'Creado:',
  'admin.downgrade.triggered': 'activado',
  'admin.downgrade.noRules': 'No se han creado reglas aún',
  'admin.downgrade.createFirstRule': 'Crear primera regla',
  'admin.downgrade.editRule': 'Editar Regla',
  'admin.downgrade.createRule': 'Crear Nueva Regla',
  'admin.downgrade.ruleName': 'Nombre de la regla',
  'admin.downgrade.description': 'Descripción',
  'admin.downgrade.allConditions': 'Condiciones (todas deben cumplirse)',
  'admin.downgrade.addCondition': 'Agregar condición',
  'admin.downgrade.type': 'Tipo',
  'admin.downgrade.value': 'Valor',
  'admin.downgrade.fromPlan': 'Desde el plan',
  'admin.downgrade.toPlan': 'Al plan',
  'admin.condition.inactivity': 'Inactividad',
  'admin.condition.creditUsage': 'Uso de Créditos',
  'admin.condition.loginFrequency': 'Frecuencia de Inicio de Sesión',
  'admin.condition.featureUsage': 'Uso de Funciones',
  'admin.condition.supportTickets': 'Tickets de Soporte',
  'admin.operator.lessThan': 'menos de',
  'admin.operator.greaterThan': 'más de',
  'admin.operator.equals': 'exactamente',
  'admin.operator.between': 'entre',
  'admin.unit.days': 'días',
  'admin.unit.perMonth': 'por mes',
  'admin.unit.count': 'cantidad',
  'admin.transactions.all': 'Todas las Transacciones',
  'admin.transactions.allCards': 'Todas las Tarjetas',
  'admin.transactions.notFound': 'No se encontraron transacciones',
  'admin.transactions.totalLabel': 'Total',
  'admin.transactions.transactions': 'transacciones',
  'admin.transactions.upgrades': 'Mejoras',
  'admin.transactions.downgrades': 'Degradaciones',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',
  'admin.tips.title': 'Consejo del Día',
  'admin.tips.subtitle': 'Crear y gestionar consejos mostrados a todos los usuarios',
  'admin.tips.active': 'Activo',
  'admin.tips.currentlyShown': 'Este consejo se muestra actualmente a todos los usuarios',
  'admin.tips.createNew': 'Crear Nuevo Consejo',
  'admin.tips.generating': 'Generando...',
  'admin.tips.generateAI': 'Generar Consejo IA',
  'admin.tips.titleLabel': 'Título',
  'admin.tips.titlePlaceholder': 'ej. Consejo del Día',
  'admin.tips.category': 'Categoría',
  'admin.tips.categoryTip': 'Consejo',
  'admin.tips.categoryFeature': 'Nueva Función',
  'admin.tips.categoryProductivity': 'Productividad',
  'admin.tips.categoryUpdate': 'Actualización',
  'admin.tips.content': 'Contenido',
  'admin.tips.contentPlaceholder': 'Escribe tu consejo para los usuarios aquí...',
  'admin.tips.addTip': 'Agregar Consejo',
  'admin.tips.allTips': 'Todos los Consejos',
  'admin.tips.noTips': 'No se han creado consejos aún',
  'admin.tips.noTipsHint': 'Haz clic en "Generar Consejo IA" para comenzar',
  'admin.noData': 'No hay datos disponibles',
  'admin.range.7d': '7 días',
  'admin.range.30d': '30 días',
  'admin.range.90d': '90 días',
  'admin.range.1y': '1 año',
  'admin.actions.saveSettings': 'Guardar configuración',
  'admin.actions.create': 'Crear',
  'admin.actions.activate': 'Activar',
  'admin.actions.deactivate': 'Desactivar',
  'admin.downgrade.sectionReports': 'Informes',
  'admin.downgrade.settings': 'Configuración de degradación',
  'admin.downgrade.autoApprove': 'Aprobación automática',
  'admin.downgrade.autoApproveDesc': 'Aprobar automáticamente las solicitudes de degradación',
  'admin.downgrade.refundPolicy': 'Política de reembolso',
  'admin.downgrade.prorata': 'Reembolso prorrateado',
  'admin.downgrade.prorataDesc': 'Reembolso proporcional basado en los días restantes',
  'admin.downgrade.fullRefund': 'Reembolso completo',
  'admin.downgrade.fullRefundDesc': 'Reembolso total de la diferencia de precio',
  'admin.downgrade.noRefund': 'Sin reembolso',
  'admin.downgrade.noRefundDesc': 'Degradación sin reembolso',
  'admin.downgrade.daysRemaining15': '(con 15 días restantes)',
  'admin.downgrade.requestsTitle': 'Solicitudes de degradación',
  'admin.downgrade.approvalRate': 'Tasa de aprobación',
  'admin.downgrade.mostCommonTransition': 'Transición más común',
  'admin.downgrade.mostCommonReason': 'Razón más común',
  'admin.downgrade.avgProcessingTime': 'Tiempo de procesamiento medio',
  'admin.downgrade.avgTimeDesc': 'Tiempo medio hasta la decisión',
  'admin.downgrade.totalRefunds': 'Total de reembolsos',
  'admin.downgrade.pendingRefunds': 'Reembolsos pendientes',
  'admin.downgrade.summary': 'Resumen',
  'admin.downgrade.total': 'Total',
  'admin.downgrade.csvDesc': 'Para Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Descargar como CSV',
  'admin.downgrade.jsonDesc': 'Para desarrolladores, APIs',
  'admin.downgrade.downloadJSON': 'Descargar como JSON',
  'admin.downgrade.exportInfo': 'La exportación contiene',
  'admin.downgrade.entries': 'entradas del período seleccionado',
  'admin.downgrade.topReasons': 'Razones de degradación más frecuentes',
  'admin.downgrade.refundHistory': 'Historial de reembolsos',
  'admin.downgrade.noRefunds': 'Aún no hay reembolsos',
  'admin.downgrade.statistics': 'Estadísticas de degradación',
  'admin.downgrade.requests': 'Solicitudes',
  'admin.downgrade.monthlyTrend': 'Tendencia mensual',
  'admin.downgrade.planTransitions': 'Transiciones de plan',
  'admin.downgrade.trend': 'Tendencia (vs mes ant.)',
  'admin.downgrade.trendDesc': 'Menos degradaciones = mejor',
  'admin.coupons.allPlansUniversal': 'Todos los planes (Universal)',
  'admin.coupons.onlyStarter': 'Solo Starter',
  'admin.coupons.onlyPro': 'Solo Pro',
  'admin.coupons.onlyBuilder': 'Solo Builder',
  'admin.coupons.allPlansHint': 'Elige "Todos los planes" para un cupón universal',
  'admin.coupons.discountOptional': 'Descuento % (opcional)',
  'admin.coupons.discountPlaceholder': 'ej. 50 para 50% de descuento',
  'admin.coupons.bonusCreditsOptional': 'Créditos bonus (opcional)',
  'admin.coupons.bonusCreditsPlaceholder': 'ej. 500',
  'admin.coupons.freeDurationOptional': 'Duración gratuita (opcional)',
  'admin.coupons.durationPlaceholder': 'ej. 30',
  'admin.coupons.freeDurationHint': 'ej. 30 días gratis',
  'admin.coupons.noLimit': 'Sin límite de uso',
  'admin.coupons.noExpiry': 'Sin fecha de vencimiento',
  'admin.coupons.creditsPlaceholder': 'ej. 100',
  'admin.coupons.creditsHint': 'Número de créditos para el acceso de prueba',
  'admin.coupons.trialDurationHint': 'Durante cuánto tiempo es válido el acceso de prueba',
  'admin.coupons.autoCalculated': 'Calculado automáticamente a partir de la duración de prueba',
  'admin.actions.close': 'Cerrar',
  'admin.websiteEditor.title': 'Editor de sitio web',
  'admin.websiteEditor.subtitle': 'Editar todas las secciones de la página de inicio',
  'admin.websiteEditor.openPreview': 'Abrir vista previa',
  'admin.websiteEditor.group.structure': 'Estructura de página',
  'admin.websiteEditor.group.design': 'Diseño y maquetación',
  'admin.websiteEditor.group.settings': 'Configuración',
  'admin.websiteEditor.tab.navbar': 'Navegación',
  'admin.websiteEditor.tab.howitworks': 'Cómo funciona',
  'admin.websiteEditor.tab.about': 'Sobre nosotros',
  'admin.websiteEditor.tab.pricing': 'Precios',
  'admin.websiteEditor.tab.sections': 'Secciones',
  'admin.websiteEditor.tab.media': 'Medios',
  'admin.websiteEditor.tab.chatwidget': 'Habla con nosotros',
  'admin.websiteEditor.tab.invoice': 'Facturas',
  'admin.websiteEditor.tab.legal': 'Legal',
  'admin.websiteEditor.tab.seo': 'SEO Básico',
  'admin.websiteEditor.tab.advancedseo': 'SEO Avanzado',
  'admin.websiteEditor.tab.versions': 'Versiones',
  'admin.websiteEditor.tab.features': 'Características',
  'admin.websiteEditor.tab.testimonials': 'Testimonios',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Pie de página',
  'admin.websiteEditor.tab.design': 'Diseño',
  'admin.websiteEditor.tab.customcode': 'Código personalizado',
  'admin.websiteEditor.tab.socials': 'Redes Sociales',
  'admin.websiteEditor.tab.importexport': 'Importar/Exportar',
  'admin.hero.title': 'Editar sección hero',
  'admin.hero.subtitle': 'Textos, botones y estadísticas de la página de inicio',
  'admin.hero.reset': 'Restablecer',
  'admin.hero.save': 'Guardar',
  'admin.hero.savedMsg': '¡Datos del hero guardados!',
  'admin.hero.badge': 'Texto del badge',
  'admin.hero.headings': 'Encabezados',
  'admin.hero.line1White': 'Línea 1 (blanca)',
  'admin.hero.line2Gold': 'Línea 2 (dorada)',
  'admin.hero.subtitleSection': 'Subtítulo',
  'admin.hero.line1': 'Línea 1',
  'admin.hero.line2': 'Línea 2',
  'admin.hero.buttons': 'Botones',
  'admin.hero.primaryBtn': 'Botón principal (dorado)',
  'admin.hero.secondaryBtn': 'Botón secundario (borde)',
  'admin.hero.stats': 'Estadísticas',
  'admin.hero.statN': 'Estadística {{n}}',
  'admin.hero.value': 'Valor',
  'admin.hero.label': 'Etiqueta',
  'admin.hero.previewNote': 'Los cambios serán visibles en la página de inicio después de guardar. Recarga la página para ver la vista previa.',
  'admin.users.grantFreeSuccess': '{{name}} ahora tiene {{months}} mes(es) de plan {{plan}} gratuito',
  'admin.users.blockSuccess': '{{name}} fue bloqueado',
  'admin.users.unblockSuccess': '{{name}} fue desbloqueado',
  'admin.users.removeFreeSuccess': 'El estado gratuito de {{name}} fue eliminado',
  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratuito',
  'admin.unit.percent': '%',
  'admin.tips.discoverNewFeature': 'Descubrir Nueva Función',
  'admin.tips.productivityBoost': 'Aumento de Productividad',
  'admin.tips.importantUpdate': 'Actualización Importante',
  'admin.tips.tipOfDay': 'Consejo del Día',
  'admin.ai.title': 'Ajustes del Asistente IA',
  'admin.ai.subtitle': 'Configurar comportamiento, estilo y profundidad de análisis',
  'admin.ai.smartWeightingActive': 'Ponderación Inteligente Activa',
  'admin.ai.smartWeightingDesc': 'La IA combina automáticamente todas las perspectivas con ponderación inteligente.',
  'admin.ai.modelTitle': 'Modelo IA de IdeaVerdict',
  'admin.ai.modelSubtitle': 'Elige el motor de IA para todos los análisis de usuarios',
  'admin.ai.activeModel': 'Modelo activo:',
  'admin.ai.activeModelDesc': 'Todos los usuarios reciben respuestas de este modelo.',
  'admin.ai.recommendations': 'Recomendaciones para Resultados Óptimos',
  'admin.ai.new': 'NUEVO',
  'admin.ai.recommendationsDesc': 'Combinaciones de presets probadas para mejor calidad de análisis',
  'admin.ai.recommendationsInfo': 'Estas combinaciones han sido testadas y entregan los mejores resultados.',
  'admin.ai.active': 'ACTIVO',
  'admin.ai.apply': 'Aplicar',
  'admin.ai.avoid': 'Evitar',
  'admin.ai.excellentQuality': 'Excelente Calidad',
  'admin.ai.goodQuality': 'Buena Calidad',
  'admin.ai.poorQuality': 'Calidad Diluida - No Recomendado',
  'admin.ai.proTips': 'Consejos Pro',
  'admin.ai.tip1Title': '2 presets son óptimos:',
  'admin.ai.tip1Desc': 'Perspectiva clara sin dilución',
  'admin.ai.tip2Title': 'El preset principal importa:',
  'admin.ai.tip2Desc': 'El primer preset tiene la mayor influencia',
  'admin.ai.tip3Title': 'Evitar opuestos:',
  'admin.ai.tip3Desc': '"EXTREMO" + "Creativo" = contradictorio',
  'admin.ai.tip4Title': 'Máximo 3 presets:',
  'admin.ai.tip4Desc': 'Con 4+ presets el resultado se vuelve demasiado general',
  'admin.ai.warningManyPresets': 'Advertencia: Muchos Presets',
  'admin.ai.warningManyPresetsDesc': 'Tienes {{count}} presets seleccionados. Esto puede diluir el resultado.',
  'admin.ai.warningRecommend': 'Recomendado: Máximo 2-3 presets',
  'admin.ai.forOptimalResults': 'para resultados óptimos.',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(selección múltiple posible)',
  'admin.ai.presetsDesc': 'Elige uno o más presets. El primer preset es el preset principal con mayor ponderación.',
  'admin.ai.primaryPreset': 'Preset Principal',
  'admin.ai.weightControl': 'Control de Peso',
  'admin.ai.weightControlDesc': 'Ajusta cuánto influye cada preset en el análisis',
  'admin.ai.manual': 'Manual',
  'admin.ai.automatic': 'Automático',
  'admin.ai.autoWeightingActive': 'Ponderación automática activa:',
  'admin.ai.autoWeightingDesc': 'La ponderación se optimiza automáticamente basándose en el número de presets.',
  'admin.ai.primary': 'PRINCIPAL',
  'admin.ai.totalWeight': 'Total',
  'admin.ai.shouldBe100': 'debe ser 100%',
  'admin.ai.normalize': 'Normalizar',
  'admin.ai.combinedSettings': 'Configuración Combinada',
  'admin.ai.presetsCount': 'presets',
  'admin.ai.strictness': 'Estrictez',
  'admin.ai.realism': 'Realismo',
  'admin.ai.creativity': 'Creatividad',
  'admin.ai.detailLevel': 'Nivel de Detalle',
  'admin.ai.customInstructions': 'Instrucciones Personalizadas',
  'admin.ai.customInstructionsDesc': 'Instrucciones adicionales que se combinan con los presets',
  'admin.ai.customInstructionsPlaceholder': 'ej. "Enfocarse en el mercado DACH", "Siempre usar números concretos"...',
  'admin.ai.customInstructionsHint': 'Estas instrucciones se combinan automáticamente con los presets seleccionados.',
  'admin.ai.manualFinetuning': 'Ajuste Fino Manual',
  'admin.ai.manualFinetuningHint': '(opcional, anula los valores del preset)',
  'admin.ai.manualFinetuningDesc': 'Ajusta manualmente los valores combinados si quieres afinar algo.',
  'admin.ai.tone': 'Tono',
  'admin.ai.mild': 'Suave',
  'admin.ai.strict': 'Estricto',
  'admin.ai.creative': 'Creativo',
  'admin.ai.realistic': 'Realista',
  'admin.ai.conservative': 'Conservador',
  'admin.ai.compact': 'Compacto',
  'admin.ai.detailed': 'Detallado',
  'admin.ai.responseLength': 'Longitud de Respuesta',
  'admin.ai.short': 'Corto y Conciso',
  'admin.ai.medium': 'Medio',
  'admin.ai.long': 'Detallado',
  'admin.ai.focusAreas': 'Áreas de Enfoque del Análisis',
  'admin.ai.autoRating': 'Calificación Automática',
  'admin.ai.autoRatingDesc': 'Cada análisis recibe automáticamente una calificación (Bueno/Medio/Malo)',
  'admin.ai.showSources': 'Mostrar Fuentes',
  'admin.ai.showSourcesDesc': 'Referencias a fuentes de datos y datos de mercado en las respuestas',
  'admin.ai.hidePreview': 'Ocultar Vista Previa',
  'admin.ai.showPreview': 'Mostrar Vista Previa',
  'admin.ai.aiBehavior': 'Comportamiento de la IA',
  'admin.ai.length': 'Longitud',
  'admin.ai.liveExample': 'Ejemplo en Vivo',
  'admin.ai.testSettings': 'Prueba tu configuración',
  'admin.ai.selectExampleQuestion': 'Selecciona pregunta de ejemplo:',
  'admin.ai.userAsks': 'El usuario pregunta:',
  'admin.ai.generating': 'La IA generando respuesta...',
  'admin.ai.generateExample': 'Generar Respuesta de Ejemplo',
  'admin.ai.aiResponds': 'El Asistente IA responde:',
  'admin.ai.generateHint': 'Haz clic en "Generar Respuesta de Ejemplo" para ver cómo responde la IA con tu configuración.',
  'admin.ai.reset': 'Restablecer',
  'admin.ai.saved': '¡Guardado!',
  'admin.ai.saveSettings': 'Guardar Configuración',
  'admin.ai.model.standardDesc': 'Análisis equilibrado con alta calidad. La mejor opción para la mayoría de evaluaciones de nichos.',
  'admin.ai.model.preciseAnalyses': 'Análisis Precisos',
  'admin.ai.model.bestBalance': 'Mejor Equilibrio',
  'admin.ai.model.recommended': 'Recomendado',
  'admin.ai.model.fastDesc': 'Respuestas ultrarrápidas para checks rápidos de nichos y brainstorming.',
  'admin.ai.model.fast': 'RÁPIDO',
  'admin.ai.model.fastestResponses': 'Respuestas Más Rápidas',
  'admin.ai.model.thinkingDesc': 'Análisis profundo con pensamiento lógico avanzado. Para análisis de mercado complejos.',
  'admin.ai.model.deepestAnalysis': 'Análisis Más Profundo',
  'admin.ai.model.logicalThinking': 'Pensamiento Lógico',
  'admin.ai.model.strategy': 'Estrategia',
  'admin.ai.preset.strict.name': 'Análisis Estricto',
  'admin.ai.preset.strict.desc': 'Crítico, basado en hechos, sin suavizar. Expone las debilidades despiadadamente.',
  'admin.ai.preset.extreme.name': 'Análisis EXTREMO',
  'admin.ai.preset.extreme.desc': 'Máxima estrictez, crítica despiadada, enfoque en el peor caso.',
  'admin.ai.preset.professional.name': 'Profesional',
  'admin.ai.preset.professional.desc': 'Objetivo, estructurado, equilibrado. Como un consultor de negocios experimentado.',
  'admin.ai.preset.realistic.name': 'Realista',
  'admin.ai.preset.realistic.desc': 'Honesto y práctico. Enfoque en implementación factible y datos de mercado reales.',
  'admin.ai.preset.creative.name': 'Creativo y Motivador',
  'admin.ai.preset.creative.desc': 'Inspirador, rico en ideas, positivo. Encuentra oportunidades y caminos no convencionales.',
  'admin.ai.preset.balanced.name': 'Equilibrado',
  'admin.ai.preset.balanced.desc': 'Buena mezcla de crítica y motivación. El modo predeterminado.',
  'admin.ai.preset.investor.name': 'Perspectiva del Inversor',
  'admin.ai.preset.investor.desc': 'Como un Capitalista de Riesgo. Enfoque en escalabilidad, ROI y estrategia de salida.',
  'admin.ai.preset.startup-coach.name': 'Coach de Startups',
  'admin.ai.preset.startup-coach.desc': 'Mentor práctico para fundadores. Enfoque en implementación rápida y MVP.',
  'admin.ai.preset.market-researcher.name': 'Investigador de Mercado',
  'admin.ai.preset.market-researcher.desc': 'Basado en datos y analítico. Análisis profundo de mercado y competencia.',
  'admin.ai.preset.risk-analyst.name': 'Analista de Riesgos',
  'admin.ai.preset.risk-analyst.desc': 'Enfoque en riesgos y escenarios de peor caso. Para planificación realista.',
  'admin.ai.focus.marktanalyse': 'Análisis de Mercado',
  'admin.ai.focus.wettbewerb': 'Competencia',
  'admin.ai.focus.monetarisierung': 'Monetización',
  'admin.ai.focus.risiken': 'Riesgos',
  'admin.ai.focus.finanzen': 'Finanzas',
  'admin.ai.focus.skalierung': 'Escalabilidad',
  'admin.ai.focus.innovation': 'Innovación',
  'admin.ai.focus.trends': 'Tendencias',
  'admin.ai.focus.differenzierung': 'Diferenciación',
  'admin.ai.focus.umsetzung': 'Implementación',
  'admin.ai.focus.zielgruppe': 'Público Objetivo',
  'admin.ai.focus.marketing': 'Marketing',
  'admin.ai.tone.direkt': 'Directo y Contundente',
  'admin.ai.tone.professionell': 'Profesional y Objetivo',
  'admin.ai.tone.ehrlich': 'Honesto y Práctico',
  'admin.ai.tone.motivierend': 'Motivador y Positivo',
  'admin.ai.tone.freundlich': 'Amigable y Solidario',
  'admin.ai.tone.akademisch': 'Académico y Analítico',
  'admin.ai.question.niche': '¿Qué nicho rentable recomiendas?',
  'admin.ai.question.evaluate': 'Evalúa mi idea: Una app para dueños de perros',
  'admin.ai.question.trends': '¿Qué tendencias tienen potencial actualmente?',
  'admin.ai.question.sharpen': '¿Cómo puedo afinar mi nicho?',
  'admin.ai.rec.bestCombination.title': '🏆 Mejor Combinación (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'Crítico pero constructivo, con pasos de acción concretos',
  'admin.ai.rec.bestCombination.useCase': 'Recomendado para la mayoría de análisis',
  'admin.ai.rec.balancedThree.title': '⚖️ Equilibrado (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'Profesional, realista y amigable para inversores',
  'admin.ai.rec.balancedThree.useCase': 'Para análisis de negocio completos',
  'admin.ai.rec.creativeDriven.title': '💡 Creativo y Motivador (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirador con consejos de implementación prácticos',
  'admin.ai.rec.creativeDriven.useCase': 'Para ideación y brainstorming',

  // Idea History
  'history.title': 'Historial de ideas',
  'history.countLabel': '{{count}} análisis',
  'history.recentLabel': 'Tus últimos análisis',
  'history.exportAll': 'Exportar todo',
  'history.searchPlaceholder': 'Buscar por título o etiquetas...',
  'history.filterAll': 'Todas las valoraciones',
  'history.loading': 'Cargando análisis...',
  'history.noResults': 'No se encontraron resultados',
  'history.empty': 'Aún no hay análisis',
  'history.emptyHint': 'Inicia un análisis en el Asistente IA',
  'history.delete': 'Eliminar',
  'history.cancel': 'Cancelar',
  'history.deleteModalTitle': '¿Eliminar análisis?',
  'history.deleteModalDesc': '"{{title}}" se eliminará permanentemente.',
  'history.errorLoading': 'Error al cargar los análisis',
  'history.deleteSuccess': 'Análisis eliminado con éxito',
  'history.deleteError': 'Error al eliminar el análisis',
  'history.jsonExported': 'JSON exportado',
  'history.txtExported': 'TXT exportado',
  'history.allExported': '{{count}} ideas exportadas',
  'history.analysisHeader': 'ANÁLISIS DE IDEA',
  'history.titleLabel': 'Título',
  'history.ratingLabel': 'Valoración',
  'history.dateLabel': 'Fecha',
  'history.creditsLabel': 'Créditos',
  'history.analysisSection': 'Análisis',

  // Overview
  'overview.title': 'Resumen',
  'overview.last24h': 'Últimas 24 horas',
  'overview.analysesToday': 'Análisis hoy',
  'overview.totalAnalyses': 'Total de análisis',
  'overview.successRate': 'Tasa de éxito',
  'overview.topRatings': 'Mejores valoraciones',
  'overview.recentActivity': 'Actividad reciente',
  'overview.viewAll': 'Ver todo',
  'overview.quickAccess': 'Acceso rápido',
  'overview.quick.newAnalysis': 'Nuevo análisis',
  'overview.quick.newAnalysisDesc': 'Iniciar un nuevo análisis de nicho IA',
  'overview.quick.myAnalyses': 'Mis análisis',
  'overview.quick.myAnalysesDesc': 'Ver todos los análisis anteriores',
  'overview.quick.buyCredits': 'Comprar créditos',
  'overview.quick.buyCreditsDesc': 'Más créditos para más análisis',
  'overview.quick.settings': 'Configuración',
  'overview.quick.settingsDesc': 'Personalizar perfil y preferencias',
  'overview.unlimitedCredits': 'Créditos ilimitados disponibles',
  'overview.creditsAvailable': 'créditos disponibles',
  'overview.upgradePlan': 'Mejorar plan',
  'overview.buyCredits': 'Comprar créditos',
  'overview.creditUsage': 'Uso de créditos este mes',
  'overview.available': 'disponible',

  // Settings
  'settings.title': 'Configuración',
  'settings.subtitle': 'Gestiona tu cuenta y preferencias',
  'settings.backToOverview': 'Volver al resumen',
  'settings.subscriptionLink': 'Suscripción y Facturación',
  'settings.saved': 'Cambios guardados con éxito',
  'settings.changesSaved': 'Cambios guardados',
  'settings.saveChanges': 'Guardar cambios',
  'settings.dataExported': 'Datos exportados con éxito',
  'settings.tabs.profile': 'Perfil',
  'settings.tabs.preferences': 'Preferencias',
  'settings.tabs.notifications': 'Notificaciones',
  'settings.tabs.account': 'Cuenta y Plan',
  'settings.profile.changePhoto': 'Cambiar foto',
  'settings.profile.photoHint': 'JPG, PNG o GIF (máx. 2MB)',
  'settings.profile.uploading': 'Subiendo...',
  'settings.profile.photoUpdated': '¡Foto de perfil actualizada!',
  'settings.profile.name': 'Nombre',
  'settings.profile.email': 'Correo',
  'settings.profile.phone': 'Teléfono',
  'settings.profile.changePassword': 'Cambiar contraseña',
  'settings.profile.currentPassword': 'Contraseña actual',
  'settings.profile.newPassword': 'Nueva contraseña',
  'settings.profile.confirmPassword': 'Confirmar contraseña',
  'settings.preferences.language': 'Idioma',
  'settings.preferences.chooseLanguage': 'Elegir idioma',
  'settings.preferences.timezone': 'Zona horaria',
  'settings.preferences.currency': 'Moneda',
  'settings.notifications.emailTitle': 'Notificaciones por Correo',
  'settings.notifications.email.analysis': 'Análisis completado',
  'settings.notifications.email.analysisDesc': 'Recibe un correo cuando tu análisis esté listo',
  'settings.notifications.email.credits': 'Actualizaciones de créditos',
  'settings.notifications.email.creditsDesc': 'Notificaciones sobre créditos y reinicios',
  'settings.notifications.email.billing': 'Facturas y Pagos',
  'settings.notifications.email.billingDesc': 'Notificaciones sobre facturas y cambios de plan',
  'settings.notifications.email.newsletter': 'Boletín',
  'settings.notifications.email.newsletterDesc': 'Consejos, actualizaciones y nuevas funciones',
  'settings.notifications.pushTitle': 'Notificaciones Push',
  'settings.notifications.push.analysis': 'Análisis completado',
  'settings.notifications.push.analysisDesc': 'Notificación del navegador cuando el análisis esté listo',
  'settings.notifications.push.credits': 'Alertas de créditos',
  'settings.notifications.push.creditsDesc': 'Alerta cuando el saldo de créditos sea bajo',
  'settings.account.currentSubscription': 'Suscripción Actual',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Precio',
  'settings.account.nextBilling': 'Próxima facturación',
  'settings.account.manageSubscription': 'Gestionar suscripción y pagos',
  'settings.account.dataPrivacy': 'Datos y Privacidad',
  'settings.account.exportData': 'Exportar datos',
  'settings.account.deleteAccount': 'Eliminar cuenta',
  'settings.deleteModal.title': '¿Eliminar cuenta?',
  'settings.deleteModal.subtitle': 'Todos los datos se eliminarán permanentemente.',
  'settings.deleteModal.warning1': 'Todos los análisis y datos serán eliminados',
  'settings.deleteModal.warning2': 'La suscripción activa se cancelará inmediatamente',
  'settings.deleteModal.warning3': 'Sin posibilidad de reembolso',
  'settings.deleteModal.confirmLabel': 'Escribe "{{word}}" para confirmar *',
  'settings.deleteModal.cancel': 'Cancelar',
  'settings.deleteModal.confirm': 'Eliminar cuenta',

  // Subscription & Billing
  'sub.backToOverview': 'Volver al resumen',
  'sub.settings': 'Configuración',
  'sub.title': 'Suscripción y Facturación',
  'sub.subtitle': 'Gestiona tu suscripción, métodos de pago y facturas',
  'sub.tab.overview': 'Resumen',
  'sub.tab.payment': 'Métodos de Pago',
  'sub.tab.billing': 'Dirección de Facturación',
  'sub.tab.history': 'Historial de Pagos',
  'sub.memberSince': 'Miembro desde',
  'sub.perMonth': 'por mes',
  'sub.baseCHF': '(CHF {{amount}} base)',
  'sub.nextBilling': 'Próxima facturación',
  'sub.creditsUsed': 'Créditos usados',
  'sub.paymentMethod': 'Método de pago',
  'sub.creditUsage': 'Uso de créditos',
  'sub.changePlan': 'Cambiar plan',
  'sub.reactivate': 'Reactivar',
  'sub.cancelSub': 'Cancelar suscripción',
  'sub.manageCards': 'Gestionar tarjetas',
  'sub.downloadInvoices': 'Descargar facturas',
  'sub.invoicesAvailable': '{{count}} facturas disponibles en PDF',
  'sub.accountSettings': 'Configuración de Cuenta',
  'sub.profileNotifications': 'Perfil, notificaciones y más',
  'sub.eurInfo': 'Precios mostrados en',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Tasa:',
  'sub.currentRate': 'Tasa actual',
  'sub.savedCards': 'Tarjetas Guardadas',
  'sub.newCard': 'Nueva Tarjeta',
  'sub.default': 'Predeterminada',
  'sub.setDefault': 'Establecer como predeterminada',
  'sub.validUntil': 'Válida hasta',
  'sub.noCards': 'Sin tarjetas guardadas',
  'sub.addFirstCard': 'Añadir primera tarjeta',
  'sub.securePayments': 'Pagos Seguros',
  'sub.securePaymentsDesc': 'Todos los datos de pago se transmiten cifrados y se almacenan de forma segura con nuestro proveedor de pagos.',
  'sub.billingAddress': 'Dirección de Facturación',
  'sub.edit': 'Editar',
  'sub.name': 'Nombre',
  'sub.streetAddress': 'Calle y Número',
  'sub.zip': 'Código Postal',
  'sub.city': 'Ciudad',
  'sub.country': 'País',
  'sub.address': 'Dirección',
  'sub.save': 'Guardar',
  'sub.cancel': 'Cancelar',
  'sub.country.switzerland': 'Suiza',
  'sub.country.germany': 'Alemania',
  'sub.country.austria': 'Austria',
  'sub.country.netherlands': 'Países Bajos',
  'sub.country.belgium': 'Bélgica',
  'sub.paymentHistory': 'Historial de Pagos',
  'sub.allInvoicesPDF': 'Descargar todas las facturas en PDF con logo',
  'sub.downloadAll': 'Descargar todas',
  'sub.eurInvoiceNote': 'Las facturas siempre se emiten en CHF. Los importes en EUR mostrados son solo de referencia.',
  'sub.date': 'Fecha',
  'sub.description': 'Descripción',
  'sub.net': 'Neto',
  'sub.vat': 'IVA',
  'sub.total': 'Total',
  'sub.status': 'Estado',
  'sub.pdf': 'PDF',
  'sub.invoices': 'facturas',
  'sub.totalAmount': 'Importe total',
  'sub.changePlanTitle': 'Cambiar Plan',
  'sub.current': 'Actual',
  'sub.month': '/mes',
  'sub.showLess': 'Mostrar menos',
  'sub.showMore': '+{{count}} más',
  'sub.switchPlan': 'Cambiar plan',
  'sub.eurPriceNote': 'Precios mostrados en EUR ({{note}}). La facturación es en CHF.',
  'sub.cancelTitle': '¿Realmente cancelar la suscripción?',
  'sub.cancelIrreversible': 'Esta acción no se puede deshacer.',
  'sub.cancelWarning1': 'Todos los créditos restantes caducarán',
  'sub.cancelWarning2': 'Cambio al Plan Gratuito',
  'sub.cancelWarning3': 'Pérdida de todas las funciones premium',
  'sub.pauseInstead': 'Alternativa: ¿Pausar suscripción?',
  'sub.pauseDesc': 'Pausa tu suscripción en su lugar y conserva tus datos.',
  'sub.preferPause': 'Prefiero pausar',
  'sub.cancelReason': 'Motivo de cancelación',
  'sub.selectReason': 'Por favor selecciona...',
  'sub.reason.tooExpensive': 'Demasiado caro',
  'sub.reason.notUsing': 'No lo uso suficiente',
  'sub.reason.missingFeatures': 'Funciones faltantes',
  'sub.reason.foundAlternative': 'Encontré una alternativa',
  'sub.reason.other': 'Otro',
  'sub.confirmType': 'Confirmación: Escribe "CANCELAR" *',
  'sub.cancelNow': 'Cancelar ahora',
  'sub.addCardTitle': 'Añadir Nueva Tarjeta',
  'sub.cardHolder': 'Titular de la Tarjeta *',
  'sub.cardNumber': 'Número de Tarjeta *',
  'sub.expiryDate': 'Fecha de Vencimiento *',
  'sub.addCard': 'Añadir tarjeta',
  'sub.choosePayment': 'Elegir método de pago',
  'sub.active': 'Activo',
  'sub.close': 'Cerrar',
  'sub.toast.cancelled': 'Tu suscripción ha sido cancelada al final del período de facturación.',
  'sub.toast.reactivated': '¡Tu suscripción ha sido reactivada con éxito!',
  'sub.toast.planChanged': '¡Plan cambiado con éxito a {{plan}}!',
  'sub.toast.defaultChanged': 'Método de pago predeterminado cambiado.',
  'sub.toast.cannotDeleteDefault': 'La tarjeta predeterminada no puede eliminarse.',
  'sub.toast.cardRemoved': 'La tarjeta ha sido eliminada.',
  'sub.toast.fillAll': 'Por favor, rellena todos los campos.',
  'sub.toast.cardAdded': '¡Nueva tarjeta añadida con éxito!',
  'sub.toast.billingSaved': 'Dirección de facturación guardada.',
  'sub.toast.invoiceDownloaded': '¡Factura {{id}} descargada!',
  'sub.toast.pdfError': 'Error al crear PDF.',
  'sub.notEnoughCredits': 'Créditos insuficientes',
  'sub.needCredits': 'Necesitas al menos {{count}} créditos por pregunta.',
  'sub.creditsLow': 'Créditos bajos',
  'sub.questionsLeft': '{{count}} preguntas posibles.',
  'sub.plan': 'Plan',
  'sub.base': 'base',
  'sub.unlimited': 'Ilimitado',
  'sub.status.active': 'Activo',
  'sub.status.cancelled': 'Cancelado',
  'sub.status.paused': 'Pausado',
  'sub.invoice': 'FACTURA',
  'sub.from': 'DE',
  'sub.to': 'PARA',
  'sub.vatId': 'NIF/CIF',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Fecha de factura',
  'sub.invoiceNumber': 'Número de factura',
  'sub.paymentStatus': 'Estado del pago',
  'sub.creditCard': 'Tarjeta de crédito',
  'sub.quantity': 'CANT.',
  'sub.price': 'PRECIO',
  'sub.amount': 'IMPORTE',
  'sub.subtotal': 'Subtotal',
  'sub.bank': 'Banco',
  'sub.card': 'Tarjeta',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Juan García',
  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Uso',
  'admin.usage.title': 'Uso de IA y Análisis de Costes',
  'admin.usage.refresh': 'Actualizar datos',
  'admin.usage.requests': 'Solicitudes',
  'admin.usage.users': 'Usuarios',
  'admin.usage.totalTokens': 'Tokens Totales',
  'admin.usage.apiCosts': 'Costes de API',
  'admin.usage.revenue': 'Ingresos',
  'admin.usage.margin': 'Margen',
  'admin.usage.byModel': 'Por Modelo',
  'admin.usage.allModels': 'Todos los Modelos',
  'admin.usage.searchEmail': 'Buscar por correo electrónico...',
  'admin.usage.perPage': 'Por página:',
  'admin.usage.loading': 'Cargando datos de uso...',
  'admin.usage.noEntries': 'No se encontraron entradas con los filtros actuales.',
  'admin.usage.time': 'Hora',
  'admin.usage.user': 'Usuario',
  'admin.usage.model': 'Modelo',
  'admin.usage.credits': 'Créditos',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duración',
  'admin.usage.details': 'Detalles',
  'admin.usage.showing': 'Mostrando',
  'admin.usage.of': 'de',
  'admin.usage.entries': 'entradas',
  'admin.usage.firstPage': 'Primera Página',
  'admin.usage.prevPage': 'Anterior',
  'admin.usage.page': 'Página',
  'admin.usage.nextPage': 'Siguiente',
  'admin.usage.lastPage': 'Última Página',
  'admin.usage.requestDetails': 'Detalles de la Solicitud',
  'admin.usage.close': 'Cerrar',
  'admin.usage.loadingDetails': 'Cargando detalles...',
  'admin.usage.inputTokens': 'Tokens de Entrada',
  'admin.usage.outputTokens': 'Tokens de Salida',
  'admin.usage.providerCost': 'Coste del Proveedor',
  'admin.usage.providerBreakdown': 'Desglose del Proveedor',
  'admin.usage.fullResponseData': 'Datos de Respuesta Completos',
  'admin.usage.entryNotFound': 'Esta entrada no pudo ser cargada.',
  'admin.usage.today': 'Hoy',
  'admin.usage.last7d': 'Últimos 7 días',
  'admin.usage.last30d': 'Últimos 30 días',
  'admin.usage.allTime': 'Todo el tiempo',
  'admin.ai.fallbackModel': 'Modelo de Respaldo',
  'admin.ai.systemPrompts': 'Prompts del Sistema',
  'admin.ai.fallbackModelDesc': 'Se usa cuando el modelo principal falla o devuelve una salida no válida',
  'admin.ai.systemPromptsDesc': 'Vista de solo lectura de las instrucciones que recibe cada modelo',
  'admin.ai.provider': 'Proveedor',
  'admin.ai.modelId': 'ID del Modelo',
  'admin.ai.maxTokens': 'Tokens Máximos',
  'admin.ai.temperature': 'Temperatura',
  'admin.ai.thinkingBudget': 'Presupuesto de Pensamiento',
  'admin.ai.supportsThinking': 'Soporta Pensamiento',
  'admin.ai.displayName': 'Nombre a Mostrar',
  'admin.ai.precise': 'Preciso',
  'admin.ai.creativeTemp': 'Creativo',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Abrir menú',
  'header.home': 'Inicio',
  'header.notifications': 'Notificaciones',
  'header.settings': 'Ajustes',
  'header.profile': 'Perfil',
  'sidebar.collapse': 'Contraer barra lateral',
  'sidebar.expand': 'Expandir barra lateral',
  'sidebar.close': 'Cerrar menú',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Volver al sitio',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Aviso legal',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubái, Emiratos Árabes Unidos (EAU)',
  'legal.imprint.seatLabel': 'Sede registrada',
  'legal.imprint.seatBody': 'Dubái, Emiratos Árabes Unidos',
  'legal.imprint.contactLabel': 'Contacto',
  'legal.imprint.contactBody': 'Los datos de contacto se facilitan a discreción exclusiva de Scherbius Technology.',
  'legal.imprint.representationLabel': 'Representación legal',
  'legal.imprint.representationBody': 'Scherbius Technology está representada por sus representantes legales conforme a la legislación de los Emiratos Árabes Unidos.',
  'legal.imprint.contentLiabilityLabel': 'Responsabilidad por los contenidos',
  'legal.imprint.contentLiabilityBody': 'Los contenidos de este sitio web se han elaborado con la mayor diligencia posible.\nNo obstante, Scherbius Technology no asume ninguna responsabilidad por la exactitud, integridad o actualidad de los contenidos.',
  'legal.imprint.linksLiabilityLabel': 'Responsabilidad por enlaces externos',
  'legal.imprint.linksLiabilityBody': 'Este sitio web puede contener enlaces a sitios externos de terceros sobre cuyo contenido no se tiene influencia.\nNo se asume responsabilidad alguna por dichos contenidos externos.',
  'legal.imprint.lawLabel': 'Legislación aplicable',
  'legal.imprint.lawBody': 'Se aplica exclusivamente la legislación de los Emiratos Árabes Unidos.\nEl fuero competente es Dubái, EAU.',

  // Overview page (auto-added)
  'overview.greeting': 'Bienvenido de nuevo',
  'overview.greetingSub': 'Esto es lo que está pasando en tu escritorio de veredictos.',
  'overview.heroCta': 'Nuevo veredicto',
  'overview.currentPlan': 'Plan actual',
  'overview.creditsLabel': 'créditos',
  'overview.usedThisCycle': 'Usados este ciclo',
  'overview.resetsOn': 'Se renueva el',
  'overview.unlimitedTitle': 'Ilimitado',
  'overview.builderPerk': 'Tienes acceso completo a Builder — sin límites.',
  'overview.runOne': 'Ejecutar un veredicto',
  'overview.lastVerdicts': 'Tus últimos 5 veredictos',
  'overview.noActivity': 'Aún no hay veredictos — inicia tu primer análisis',
  'overview.tipTitle': 'Tip',
  'overview.tipBody': 'Pasa una idea por dos idiomas — si el veredicto se suaviza, tus supuestos son locales, no universales.',
  'onboard.skip': "Omitir",
  'onboard.cta.next': "Siguiente",
  'onboard.cta.start': "Comenzar",
  'onboard.s1.title': "Bienvenido a IdeaVerdict",
  'onboard.s1.body': "Un veredicto de IA sobre tu idea de negocio — antes de construirla.",
  'onboard.s2.title': "Veredictos brutalmente honestos",
  'onboard.s2.body': "Sin exageraciones, sin halagos. Datos de mercado reales, competidores reales, riesgos reales.",
  'onboard.s3.title': "Informes Builder en PDF",
  'onboard.s3.body': "Genera informes de 25 a 75 páginas con arquitectura completa, finanzas y estrategia go-to-market.",
  'onboard.s4.title': "Listo cuando lo estés",
  'onboard.s4.body': "Regístrate y obtén tu primer veredicto en menos de un minuto.",
  'builderReport.title': "Creando tu Builder Report",
  'builderReport.subtitle': "Análisis completo + briefing de desarrollador — se descarga como PDF cuando esté listo.",
  'builderReport.idea': "Tu idea",
  'builderReport.ideaPlaceholder': "Describe tu idea de negocio (o déjalo vacío para usar la última idea discutida)…",
  'builderReport.cta': "Generar informe",
  'builderReport.credits': "créditos",
  'builderReport.deductedNow': "Se descontará al completarse",
  'builderReport.dontClose': "Por favor no cierres esta ventana — la generación puede tardar 30-90 segundos.",
  'builderReport.done': "PDF descargado — revisa tu carpeta de descargas.",
  'builderReport.failed': "Generación fallida",
  'builderReport.close': "Cerrar",
  'builderReport.cancel': "Cancelar",
  'builderReport.running': "Generando…",
  'builderReport.retry': "Reintentar",
  'builderReport.unknownError': "Generación fallida. Tus créditos deben ser reembolsados.",
  'builderReport.signInRequired': "Debes iniciar sesión para generar un informe.",
  'builderReport.ideaRequired': "Por favor describe tu idea para que la IA tenga algo que analizar.",
  'builderReport.fromChat': "De tu conversación actual",
  'builderReport.noIdeaDetected': "Usaremos la idea que hemos estado discutiendo.",
  'builderReport.contextHint': "La IA usará todo de este chat — no se inventará una nueva idea.",
  'builderReport.step.core': "Generando análisis principal",
  'builderReport.step.market': "Añadiendo análisis de mercado extendido",
  'builderReport.step.tech': "Añadiendo arquitectura técnica",
  'builderReport.step.financials': "Añadiendo modelos financieros",
  'builderReport.step.compet': "Añadiendo inteligencia competitiva",
  'builderReport.step.gtm': "Añadiendo estrategia go-to-market",
  'builderReport.step.deepdive': "Añadiendo análisis sectorial profundo",
  'builderReport.step.pdf': "Compilando el PDF…",
  'briefing.title': "Creando tu briefing de desarrollador",
  'briefing.subtitle': "Briefing técnico de 11 secciones — se descarga como PDF cuando esté listo.",
  'briefing.ideaPlaceholder': "Describe tu idea de negocio (o déjalo vacío para usar la última idea discutida)…",
  'briefing.cta': "Generar briefing",
  'briefing.step.core': "Generando briefing de desarrollador",
  'briefing.step.pdf': "Compilando el PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Más créditos + informes de 50 páginas",
  'pricing.gold.credits': "12.500 créditos al mes",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Nivel máximo + informes de 75 páginas",
  'pricing.platinum.credits': "15.000 créditos al mes",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "es" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'admin.users.expired': '(Expired)',
  'admin.users.total': 'Total:',
  'admin.users.usersLabel': 'users',
  'admin.users.free': 'free',
  'admin.users.block': 'Block',
  'admin.users.unblock': 'Unblock',
  'admin.users.selectAction': 'Select action',
  'admin.users.cancelSub': 'Cancel subscription',
  'admin.users.cancelSubDesc': 'Cancellation at end of month',
  'admin.users.pauseSub': 'Pause subscription',
  'admin.users.pauseSubDesc': 'Temporary pause',
  'admin.users.changePlan': 'Change plan',
  'admin.users.changePlanDesc': 'Switch to another plan',
  'admin.users.reactivateSub': 'Reactivate subscription',
  'admin.users.reactivateDesc': 'Undo cancellation',
  'admin.users.alreadyCancelled': 'Subscription already cancelled',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Cancellation reason (optional)',
  'admin.users.cancelInfo1': 'The subscription will end on',
  'admin.users.cancelInfo2': '(end of month). Until then the user has full access. No refund.',
  'admin.users.newPlan': 'New plan',
  'admin.users.warning': 'Warning',
  'admin.users.blockDesc': 'The user will be immediately logged out and cannot log in again. All active sessions will be terminated.',
  'admin.users.confirmUnblock': 'Confirm unblock',
  'admin.users.unblockDesc': 'The user can log in again and use all features.',
  'admin.users.afterBlock': 'After blocking:',
  'admin.users.afterUnblock': 'After unblocking:',
  'admin.users.noAccountAccess': 'No account access',
  'admin.users.noNewAnalyses': 'No new analyses possible',
  'admin.users.creditsStored': 'Credits and history remain stored',
  'admin.users.accessRestored': 'Account access restored',
  'admin.users.allFeaturesAvail': 'All features available again',
  'admin.users.creditsPreserved': 'Credits and history preserved',
  'admin.users.downgrade': 'Downgrade Plan',
  'admin.users.grantFreeBtn': 'Grant free',
  'admin.users.durationMonths': 'Duration (months)',
  'admin.users.months': 'month(s)',
  'admin.users.freePlan': 'free',
  'admin.users.freeSummary': 'receives',
  'admin.users.withCredits': 'with',
  'admin.users.credits': 'Credits',
  'admin.users.subInfo': 'Subscription Information',
  'admin.users.currentPlan': 'Current Plan',
  'admin.users.joined': 'Joined',
  'admin.users.totalSpent': 'Total Spent',
  'admin.users.paymentMethod': 'Payment Method',
  'admin.users.validThrough': 'Valid through',
  'admin.users.billingAddress': 'Billing Address',
  'admin.users.transactionHistory': 'Transaction History',
  'admin.users.cancellationDate': 'Cancellation date',
  'admin.users.validUntil': 'Valid until (end of month)',
  'admin.users.cancellationReason': 'Cancellation reason',
  'admin.users.noReason': 'No reason given',
  'admin.users.timeRemaining': 'Time remaining',
  'admin.users.daysUntilDeactivation': 'days until deactivation',
  'admin.table.status': 'Status',
  'history.metrics.marketSize': 'Market Size',
  'history.metrics.competition': 'Competition',
  'history.metrics.startingCapital': 'Starting Capital',
  'history.metrics.timeToMarket': 'Time to Market',
  'history.metrics.profitPotential': 'Profit Potential',
  'history.metrics.scalability': 'Scalability',
  'history.summary.title': 'Summary',
  'history.download': 'Download',
  'history.downloadJSON': 'Save as JSON',
  'history.downloadTXT': 'Save as TXT',
  'history.downloadPDF': 'Save as PDF',
  'history.fullAnalysis': 'Full Analysis',
  'admin.coupons.code': 'Code',
  'admin.coupons.credits': 'Credits',
  'trial.creditsLow': "¡Solo quedan {{count}} créditos!",
  'trial.upgradeNow': "Actualizar ahora",
  'trial.upgradeNowArrow': "Actualizar ahora →",
  'trial.creditsExhausted': "Créditos agotados",
  'trial.upgradeForUnlimited': "Actualiza para uso ilimitado",
  'trial.noCreditsPlaceholder': "No quedan créditos…",
  'hero.badgeHonest': "IA honesta e imparcial",
  'hero.badge60sec': "Veredicto en 60 segundos",
  'hero.badge20Lang': "20+ idiomas",
  'hero.widget.label': "Veredicto de la idea",
  'hero.widget.passed': "APROBADO",
  'hero.widget.demoIdea': "Tutor de IA para estudiantes de medicina",
  'hero.widget.market': "Mercado",
  'hero.widget.demand': "Demanda",
  'hero.widget.competition': "Competencia",
  'hero.widget.verdictReady': "Veredicto listo · 47 seg",
  'hero.widget.riskFlagged': "Riesgo marcado",
  'hero.widget.crowdedMarket': "Mercado saturado · 4 actores",
  'hero.widget.suggestedPivot': "Pivote sugerido",
  'hero.widget.nicheBySpecialty': "Nicho por especialidad",
  'hero.widget.feasibilityGain': "+38% de factibilidad",
  'hero.widget.analysisDone': "Análisis listo",
  'hero.widget.metrics56': "5 de 6 métricas",
  'hero.stats.verdictSpeed': "Velocidad del veredicto",
  'cta.badge': "Veredicto en 60 segundos",
  'cta.subtitleEnd': "sin adivinar.",
  'cta.signinPrompt': "¿Ya tienes una cuenta? Inicia sesión",
  'cta.trustTrial': "Prueba gratuita de 7 días",
  'cta.trustNoCard': "Sin tarjeta requerida",
  'cta.trustCancel': "Cancela cuando quieras",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Modo claro",
  'footer.darkMode': "Modo oscuro",
  'footer.sectionProduct': "Producto",
  'footer.sectionLegal': "Legal",
  'nav.switchLight': "Cambiar al modo claro",
  'nav.switchDark': "Cambiar al modo oscuro",
  'features.badge': "Por qué IdeaVerdict",
  'features.mainFeatureLabel': "Título",
  'chatError.planRestriction': "Esta función requiere un plan superior.",
  'chatError.creditDeduction': "Error al procesar el pago. Inténtalo de nuevo.",
  'chatError.aiService': "El servicio de IA no está disponible temporalmente. No se cobraron tus créditos. Inténtalo de nuevo.",
  'chatError.parseError': "Se recibió un formato de respuesta inesperado. Inténtalo de nuevo.",
  'chatError.sessionExpired': "Tu sesión ha expirado. Inicia sesión de nuevo.",
  'chatError.timeout': "La solicitud tardó demasiado. Inténtalo de nuevo.",
  'chatError.generic': "No se pudo obtener respuesta. Inténtalo de nuevo.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "es" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report de 25 páginas",
  'pricing.gold.report': "Builder Report de 50 páginas",
  'pricing.platinum.report': "Builder Report de 75 páginas",
  'auth.bestValue': "Mejor valor",
  'auth.elite': "Élite",
  'builderReport.friendlyError': "No pudimos terminar tu informe esta vez. No se cobraron tus créditos — inténtalo de nuevo en un momento.",
  'builderReport.persistHint': "Si esto sigue ocurriendo, contacta a support@ideaverdict.ai.",
};
